import React from 'react';
import { connect, ConnectedProps } from '@cerebral/react';
import { state, sequences, props } from 'app/pwa/app.cerebral';

import {
  IndInfoWrapper,
  IndInfoClose,
  InfoCloseIcon,
  Wrapper,
} from './elements';

import { useText, useFormatIndicator } from 'common/hooks';
import { getIndicator, getIndicatorConfig } from 'utils/common';

type Props = {
  readonly indicator: string;
};

const deps = {
  activity:
    state.appContainer.activities[state.challenge.activityModal.activityKey],
  activityKey: state.challenge.activityModal.activityKey,
  showMoreInfo: state.challenge.activityModal.showMoreInfo[props`indicator`],
  toggleIndicatorExpanded: sequences`challenge.activityModal.toggleIndicatorExpanded`,
};

export function Indicator({
  indicator,
  activity,
  activityKey,
  showMoreInfo,
  toggleIndicatorExpanded,
}: Props & typeof deps & ConnectedProps): React.ReactElement {
  const t = useText();
  const formatIndicator = useFormatIndicator();
  const rawValue = getIndicator(activity.indicators, indicator);
  const value = rawValue ? formatIndicator(rawValue, indicator) : null;
  const { color, icon } = getIndicatorConfig(indicator);
  const infoPath = `challenge.activities.${activityKey}.${indicator}_explanation`;
  const hasMoreInfoFromCMS = Boolean(
    activity.indicatorsDescription?.[indicator]
  );
  const hasMoreInfo = hasMoreInfoFromCMS || t.has(infoPath);

  return (
    <>
      <Wrapper
        showInfoButton={!showMoreInfo}
        last
        icon={icon}
        color={color}
        expandable={hasMoreInfo}
        onClick={() => toggleIndicatorExpanded({ indicator })}
        label={t(`challenge.ActMod02.${indicator}_text`)}
        value={value}
      />
      <IndInfoWrapper hide={!showMoreInfo || !hasMoreInfo}>
        {hasMoreInfo &&
          (hasMoreInfoFromCMS
            ? t.markdown(activity.indicatorsDescription?.[indicator])
            : t(infoPath))}
      </IndInfoWrapper>
      <IndInfoClose
        hide={!showMoreInfo || !hasMoreInfo}
        onClick={() => toggleIndicatorExpanded({ indicator })}
      >
        <InfoCloseIcon icon={'icon-keyboard_arrow_up'} color={'#78909c'} />
      </IndInfoClose>
    </>
  );
}

export default connect<Props, typeof deps>(deps, Indicator);
